/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GoogleAuthControllerTriggerUserAuth$Params {
  tenant: string;
  email: string;
}

export function googleAuthControllerTriggerUserAuth(http: HttpClient, rootUrl: string, params: GoogleAuthControllerTriggerUserAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, googleAuthControllerTriggerUserAuth.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

googleAuthControllerTriggerUserAuth.PATH = '/thalea-google-events/google-auth/{tenant}/{email}';
